function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "color",
  points: "100.0,195.26279441628827 17.499999999999986,147.6313972081441 17.5,52.36860279185587 100.0,4.7372055837117415 182.5,52.36860279185588 182.5,147.63139720814414",
  stroke: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0,
  points: "17.499999999999986,147.6313972081441 100.0,4.7372055837117415 182.5,147.63139720814414",
  stroke: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.6,
  points: "182.5,147.63139720814414 100.0,4.7372055837117415 182.5,52.36860279185588",
  stroke: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.6,
  points: "17.499999999999986,147.6313972081441 182.5,147.63139720814414 100.0,195.26279441628827",
  stroke: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.6,
  points: "17.499999999999986,147.6313972081441 100.0,4.7372055837117415 17.5,52.36860279185587",
  stroke: "black"
});

var SvgD8 = function SvgD8(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    baseProfile: "full",
    height: "200px",
    viewBox: "0 0 200 200",
    width: "200px",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgD8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d8.1014093a.svg";
export { ForwardRef as ReactComponent };